function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 8,
  fill: "#E9EBEC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 8l-6 3.464V4.536L12 8z",
  fill: "#3A3A3A"
});

function SvgPlayinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgPlayinline;